export const GET_PURCHASE_STATUS_LIST = "GET_PURCHASE_STATUS_LIST";
export const GET_PURCHASE_KEYWORD_LIST = "GET_PURCHASE_KEYWORD_LIST";

export const PURCHASE_LIST_ACTION = "PURCHASE_LIST_ACTION";
